
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/myalbums",
      function () {
        return require("private-next-pages/myalbums/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/myalbums"])
      });
    }
  